module.exports = __webpack_public_path__ + "static/media/placeholder.0c8d438e.png";